export default __webpack_public_path__ + "static/media/icon-feather-edit.dfda7868.svg";